export default __webpack_public_path__ + "static/ekyc_as-a-service-2ed902db3f6747c5c1903592b74547c8.png";